module.exports = __webpack_public_path__ + "static/img/2.fd13b6df.png";